import { t } from '@/plugins/i18n'

export const columns = [

  {
    label: t('序号'),
    prop: 'index',
    align: 'center',
    slotName: 'index'
  },
  {
    label: t('商品情报'),
    prop: 'shoppingInfo',
    align: 'center',
    slotName: 'shoppingInfo',
    width: 160
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center'
  },
  {
    label: t('客户sku'),
    prop: 'customerProductMsku',
    align: 'center'
  },
  {
    label: t('THE CKB sku'),
    prop: 'productSku',
    align: 'center'
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionDTOList',
    align: 'center',
    slotName: 'platformOrderItemAdditionDTOList',
    width: 220
  },
  {
    label: t('结算状态'),
    prop: 'settleStatus',
    align: 'center',
    slotName: 'settleStatus'
  },
  {
    label: t('商品状态'),
    prop: 'shoppingStats',
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('实际清算数量'),
    prop: 'settlementQuantity',
    align: 'center',
    slotName: 'settlementQuantity'
  },
  {
    label: t('全包单价'),
    prop: 'allIncludeProductPrice',
    align: 'center',
    slotName: 'allIncludeProductPrice'
  },
  {
    label: t('合计金额（清算后）'),
    prop: 'allIncludeProductTotalPrice',
    align: 'center',
    slotName: 'allIncludeProductTotalPrice'
  },
  {
    label: t('费用明细'),
    prop: 'feeDetail',
    align: 'center',
    slotName: 'feeDetail'
  }
]

export const tableConfig = {
  setHeight: true,
  rowKey: 'platformOrderItemId'
}
